import { AddressType } from '@clearcover/core-app-types';

const normalizeAddress = (address: AddressType): AddressType => ({
  address1: address.address1 || '',
  address2: address.address2 || '',
  city: address.city || '',
  state: address.state || '',
  zip: address.zip || '',
});

export const areSameAddress = (
  address1: AddressType,
  address2: AddressType
) => {
  const normalizedAddress1 = normalizeAddress(address1);
  const normalizedAddress2 = normalizeAddress(address2);

  const isSameAddress =
    normalizedAddress1.address1 === normalizedAddress2.address1 &&
    normalizedAddress1.address2 === normalizedAddress2.address2 &&
    normalizedAddress1.city === normalizedAddress2.city &&
    normalizedAddress1.state === normalizedAddress2.state &&
    normalizedAddress1.zip === normalizedAddress2.zip;

  return isSameAddress;
};

export function capitalizeFirstLetter(input: string): string {
  if (input.length === 0) {
    return input;
  }

  return input.charAt(0).toUpperCase() + input.slice(1);
}

export function transformEnum(enumValue: string): string {
  if (!enumValue) {
    return '';
  }

  // Replace underscores with spaces
  let transformed = enumValue.replace(/_/g, ' ');

  // Lowercase all letters
  transformed = transformed.toLowerCase();

  // Capitalize first letter of each word
  transformed = transformed.replace(/\b\w/g, match => match.toUpperCase());

  return transformed;
}

export function convertToToggleValue(
  value: boolean | undefined
): string | undefined {
  return typeof value === 'boolean' ? value.toString() : undefined;
}

export function convertFromToggleValue(
  value: 'true' | 'false' | undefined
): boolean | undefined {
  return value ? value === 'true' : undefined;
}

export const getOrdinalSuffix = (num: number): string => {
  const j = num % 10;
  const k = num % 100;
  if (j === 1 && k !== 11) {
    return `${num}st`;
  }
  if (j === 2 && k !== 12) {
    return `${num}nd`;
  }
  if (j === 3 && k !== 13) {
    return `${num}rd`;
  }
  return `${num}th`;
};

export const distinctValues = <T>(arr: T[]): T[] => {
  return Array.from(new Set(arr));
};
